var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,0C26.4,0,0,26.4,0,58.2v395.6C0,485.6,26.4,512,58.2,512h395.6c31.8,0,58.2-26.4,58.2-58.2V58.2 C512,26.4,485.6,0,453.8,0H58.2z M58.2,46.5h395.6c6.6,0,11.6,5,11.6,11.6v395.6c0,6.6-5,11.6-11.6,11.6H58.2 c-6.6,0-11.6-5-11.6-11.6V58.2C46.5,51.5,51.5,46.5,58.2,46.5z M126.5,86.5c-22.1,0-40,17.9-40,40s17.9,40,40,40s40-17.9,40-40 S148.6,86.5,126.5,86.5z M336.7,192.7c-33.4,0-55.5,18.3-64.7,35.6h-1.5v-30.5H205v221.1h68.4V309.8c0-28.8,5.7-56.7,41.5-56.7 c35.2,0,35.6,32.5,35.6,58.2v107.6h68.4V297.5C418.9,238,406.3,192.7,336.7,192.7z M93.1,197.8v221.1h69.1V197.8H93.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin6);
export default __webpack_public_path__ + "static/media/linkedin_6.aa332d24600eca63d5b63123437dcd57.svg";
export { ForwardRef as ReactComponent };